/* This file is based on restaurants and bars of Sejour Mint */
/* This files contains for ALL food types the foods photos (more than 1) and overall description */
/* foods types: food, drinks, and other features */

export const restAndBarsSM = {
    name: 'Hotel Sejour Mint - Restaurant and Bar',
    nameJ: 'ホテルセジュールミント - レストランとバー',
    nameCh1: 'Hotel Sejour Mint - 餐厅和酒吧',
    nameCh2: 'Hotel Sejour Mint - 餐廳和酒吧',
    text: 'Hotel Sejour Mint features both a restaurant and a bar. The restaurant offers a selection of Western and Japanese dinners in addition to breakfast. If it’s your first time trying Shabu Shabu, Sukiyaki, or Nabe, don’t worry—we provide easy-to-follow instructions. The bar serves Asahi beer, Hakuba local brews, as well as a variety of whiskey, gin, Japanese shochu, and sake, along with light snacks.',
    textJ: 'ホテルセジュールミントには、レストランとバーがあります。レストランでは朝食に加えて、厳選された洋食と和食のディナーを提供しています。初めてしゃぶしゃぶ、すき焼き、または鍋を食べる方もご安心ください。わかりやすい説明をご用意しています。バーでは、アサヒビールや白馬の地ビール、ウイスキー、ジン、日本の焼酎や日本酒、そして軽食もお楽しみいただけます。',
    textCh1: 'Hotel Sejour Mint 设有餐厅和酒吧。餐厅除了提供早餐外，还供应精选的西式和日式晚餐。如果这是您第一次尝试涮涮锅、寿喜烧或火锅，不用担心，我们会提供详细的指导。酒吧供应朝日啤酒和白马当地啤酒，还有各种威士忌、杜松子酒、日本烧酒和清酒，此外还有小吃。',
    textCh2: 'Hotel Sejour Mint 設有餐廳和酒吧。餐廳除了提供早餐外，還供應精選的西式和日式晚餐。如果這是您第一次嘗試涮涮鍋、壽喜燒或火鍋，不用擔心，我們會提供詳細的指導。酒吧提供朝日啤酒和白馬當地啤酒，還有各種威士忌、杜松子酒、日本燒酒和清酒，此外還有小吃。',
    images: [
        {
            id: 0, 
            image: 'assets/images/foods/sm/sm-restaurant.jpg'
        },
        {
            id: 1, 
            image: 'assets/images/foods/sm/sm-bar.jpg'
        },
        {
            id: 2, 
            image: 'assets/images/foods/sm/sm-shabu.jpg'
        }
    ],
    restaurants: {
        name: 'Restaurant',
        nameJ: 'レストラン',
        nameCh1: '餐厅',
        nameCh2: '餐廳',
        text: 'We serve breakfast and dinner daily. For breakfast, we offer a rotating selection of options. For dinner, guests should make reservations in advance and can choose from the dinner menu. Vegetarian and vegan meals are available upon request with prior notice.',
		textJ: '毎日、朝食と夕食をご提供しています。朝食には日替わりメニューをご用意しております。夕食をご希望のお客様は、事前にご予約ください。ディナーメニューからお選びいただけます。ベジタリアンやヴィーガン向けのお食事も、事前にご連絡いただければ対応いたします。',
		textCh1: '我们每天提供早餐和晚餐。早餐提供多样化的轮换菜单。晚餐需要提前预订，您可以从晚餐菜单中选择。我们也提供素食和纯素餐点，需提前告知。',
		textCh2: '我們每天供應早餐和晚餐。早餐提供多樣化的輪換菜單。晚餐需要提前預約，客人可以從晚餐菜單中選擇。如有需要，我們提供素食和純素食餐點，請提前告知。',
        foods: [
            {
            id: 0,
            category: 'foods',
            name: 'Breakfast',
            nameJ: '朝食',
            nameCh1: '早餐',
            nameCh2: '早餐',
            text: 'Our breakfast is designed to offer a balanced meal, including carbohydrates, protein (such as sausage, ham, and eggs), and other nutrients (like salad and juice). Additionally, our food bar offers coffee, tea, juice, yogurt, and cereal. Breakfast is served daily from 7:30 to 8:30 AM.',
            textJ: '朝食は、炭水化物、タンパク質（ソーセージ、ハム、卵）、そしてその他の栄養素（サラダやジュース）を含むバランスの取れた食事をご提供しています。さらに、フードバーではコーヒー、紅茶、ジュース、ヨーグルト、シリアルもご用意しています。朝食は毎日7時30分から8時30分まで提供しています。',
            textCh1: '我们的早餐旨在提供均衡的膳食，包括碳水化合物、蛋白质（如香肠、火腿和鸡蛋），以及其他营养（沙拉、果汁）。此外，我们的自助餐区还提供咖啡、茶、果汁、酸奶和麦片。早餐供应时间为每天早上7:30到8:30。',
            textCh2: '我們的早餐旨在提供均衡的膳食，包括碳水化合物、蛋白質（如香腸、火腿和雞蛋），以及其他營養（沙拉、果汁）。此外，我們的自助餐區還提供咖啡、茶、果汁、酸奶和麥片。早餐供應時間為每天早上7:30到8:30。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/foods/sm/foods-bkft-0.jpg',
                    name: 'Breakfast variation 1: JPY 1,500',
                    nameJ: '朝食のバリエーション1: 1,500円',
                    nameCh1: '早餐变体1：1500日元',
                    nameCh2: '早餐變體1：1500日圓',
                    text: 'We offer several variations, typically adjusting the preparation of eggs, meats, and other ingredients. This is one of those variations.',
                    textJ: 'いくつかのバリエーションをご用意しており、通常は卵や肉、その他の食材の調理方法を変えています。こちらはその一つです。',
                    textCh1: '我们有几种变体，通常会改变鸡蛋、肉类及其他食材的烹饪方式。这是其中的一种。',
                    textCh2: '我們有幾種變體，通常會改變雞蛋、肉類及其他食材的烹飪方式。這是其中的一種。'
                },
                {
                    id: 1,
                    image: 'assets/images/foods/sm/foods-bkft-1.jpg',
                    name: 'Breakfast variation 2: JPY 1,500',
                    nameJ: '朝食のバリエーション2: 1,500円',
                    nameCh1: '早餐变体2：1500日元',
                    nameCh2: '早餐變體2：1500日圓',
                    text: 'This is another variation of breakfast.',
                    textJ: 'これは朝食の別のバリエーションです。',
                    textCh1: '这是早餐的另一种变体。',
                    textCh2: '這是早餐的另一種變體。'
                },
                {
                    id: 2,
                    image: 'assets/images/foods/sm/foods-bkft-2.jpg',
                    name: 'Breakfast variation 3: JPY 1,500',
                    nameJ: '朝食のバリエーション3: 1,500円',
                    nameCh1: '早餐变体3：1500日元',
                    nameCh2: '早餐變體3：1500日圓',
                    text: 'This is another variation of breakfast. ',
                    textJ: 'これはまた別の朝食のバリエーションです。',
                    textCh1: '这又是一个早餐的变体。',
                    textCh2: '這又是一個早餐的變體。'
                },
                {
                    id: 3,
                    image: 'assets/images/foods/sm/foods-bkft-3.jpg',
                    name: 'Breakfast food bar',
                    nameJ: '朝食フードバー',
                    nameCh1: '早餐食品吧台',
                    nameCh2: '早餐食品吧台',
                    text: 'We also have a self-service food bar where you can find coffee, tea, milk, juice, cereal, and more to complement your breakfast.',
                    textJ: 'セルフサービスのフードバーもあり、コーヒー、紅茶、牛乳、ジュース、シリアルなどを朝食と一緒にお楽しみいただけます。',
                    textCh1: '我们还有一个自助餐吧，您可以找到咖啡、茶、牛奶、果汁、麦片等，以搭配您的早餐。',
                    textCh2: '我們還有一個自助餐吧，您可以找到咖啡、茶、牛奶、果汁、麥片等，以搭配您的早餐。'
                }
                ]
            },
            {
            id: 1,
            category: 'foods',
            name: 'Dinner - Western',
            nameJ: '西洋風夕食',
            nameCh1: '西洋风晚餐',
            nameCh2: '西洋風晚餐',
            text: 'Our Western dinner options include hamburgers, grilled chicken, and fried chicken. Each meal comes with an appetizer, vegetables (salad or cooked), and a dessert. The price for any of these options is JPY 3,000.',
            textJ: '私たちの西洋料理の夕食メニューには、ハンバーガー、グリルチキン、フライドチキン。各食事には、前菜、野菜（サラダまたは調理された野菜）、デザートが付いています。どのオプションも価格は3,000円です。',
            textCh1: '我們的西式晚餐選擇包括漢堡、烤雞、和炸雞。每餐都附有開胃菜、蔬菜（沙拉或熟菜）和甜點。這些選擇的價格均為3,000日元。',
            textCh2: '我們的西式晚餐選擇包括漢堡、烤雞、和炸雞。每餐都附有前菜、蔬菜（沙拉或熟菜）和甜點。這些選擇的價格均為3,000日圓。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/foods/sm/foods-dinnerW-0.jpg',
                    name: 'Hamburgers: JPY 3,000',
                    nameJ: 'ハンバーガー: 3,000円',
                    nameCh1: '汉堡包：3,000日元',
                    nameCh2: '漢堡包：3,000日圓',
                    text: 'This juicy Japanese-style hamburger is served differently from the typical hamburgers found in Western countries, while being just as delicious and satisfying.',
                    textJ: 'このジューシーな和風ハンバーガーは、西洋諸国で見かける典型的なハンバーガーとは異なるスタイルで提供されますが、その美味しさと満足感は同じです。',
                    textCh1: '这款多汁的日式汉堡与西方国家常见的典型汉堡有所不同，但同样美味且令人满足。',
                    textCh2: '這款多汁的日式漢堡與西方國家常見的典型漢堡有所不同，但同樣美味且令人滿足。'
                },
                {
                    id: 1,
                    image: 'assets/images/foods/sm/foods-dinnerW-1.jpg',
                    name: 'Grilled chicken: JPY 3,000',
                    nameJ: 'グリルチキン: 3,000円',
                    nameCh1: '烤雞：3,000日元',
                    nameCh2: '烤雞：3,000日圓',
                    text: 'The grilled chicken, well marinated, is both flavorful and juicy. It remains a crowd favorite due to its rich taste and tender texture.',
                    textJ: 'よくマリネされたグリルチキンは、風味豊かでジューシーです。その豊かな味わいと柔らかな食感が、非常に人気のある一品です。',
                    textCh1: '这道经过充分腌制的烤鸡肉，味道丰富且多汁。由于其浓郁的味道和嫩滑的口感，一直是非常受欢迎的菜肴。',
                    textCh2: '這道經過充分醃製的烤雞肉，味道豐富且多汁。由於其濃郁的味道和嫩滑的口感，一直是非常受歡迎的菜肴。'
                },
                {
                    id: 2,
                    image: 'assets/images/foods/sm/foods-dinnerW-2.jpg',
                    name: 'Fried chicken: JPY 3,000',
                    nameJ: 'フライドチキン: 3,000円',
                    nameCh1: '炸雞：3,000日元',
                    nameCh2: '炸雞：3,000日圓',
                    text: 'The juicy and tender fried chicken dish is another popular choice.',
                    textJ: 'ジューシーで柔らかいフライドチキンは、他にも人気のある一品です。',
                    textCh1: '脆皮炸雞是另一道受歡迎的菜肴，肉質鮮嫩多汁。',
                    textCh2: '脆皮炸雞是另一道非常受歡迎的菜肴，雞肉鮮嫩多汁，口感極佳。'
                }
                ]
            },
            {
            id: 2,
            category: 'foods',
            name: 'Dinner - Japanese',
            nameJ: '和式夕食',
            nameCh1: '日式晚餐',
            nameCh2: '日式晚餐',
            text: 'Our Japanese dinner options feature Chicken Nabe, a flavorful soup cooked in clay pots with chicken, vegetables, and tofu; Shabu-Shabu, a hotpot with Nagano Wagyu beef and Hakuba pork, served with vegetables and tofu; and Sukiyaki, which consists of pan-braised Nagano Wagyu beef with vegetables, mushrooms, and tofu. Each dish offers a delicious and authentic Japanese dining experience.',
            textJ: '私たちの和式夕食メニューには、以下の料理があります。鶏鍋（チキン鍋）は、鶏肉、野菜、豆腐を使った風味豊かなスープを土鍋で調理した料理です。しゃぶしゃぶは、長野県産和牛と白馬産豚肉を使った鍋料理で、野菜と豆腐とともに提供されます。すき焼きは、長野県産和牛を野菜、きのこ、豆腐とともに煮込んだ料理です。どの料理も、美味しく本格的な日本の食事体験を提供します。',
            textCh1: '我们的日式晚餐选项包括鸡肉锅，这是一种用土锅煮制的风味浓郁的汤，配有鸡肉、蔬菜和豆腐；涮涮锅，使用长野和牛和白马猪肉的火锅，配有蔬菜和豆腐；以及寿喜烧，由长野和牛与蔬菜、蘑菇和豆腐一起煎炖而成。每道菜都提供了美味而地道的日本用餐体验。',
            textCh2: '我們的日式晚餐選擇包括雞肉鍋，這是一種用土鍋煮製的風味濃郁的湯，配有雞肉、蔬菜和豆腐；涮涮鍋，使用長野和牛和白馬豬肉的火鍋，配有蔬菜和豆腐；以及壽喜燒，由長野和牛與蔬菜、蘑菇和豆腐一起煎炖而成。每道菜都提供了美味而地道的日本用餐體驗。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/foods/sm/foods-dinnerJ-0.jpg',
                    name: 'Chicken Nabe: JPY 4,500',
                    nameJ: 'チキン鍋: 4,500円',
                    nameCh1: '鸡肉锅：4,500日元',
                    nameCh2: '雞肉鍋：4,500日圓',
                    text: 'A Japanese winter favorite, Nabe features fresh vegetables and chicken cooked in a hotpot, finishing with udon noodles and rice.',
                    textJ: '日本の冬の定番である鍋料理は、新鮮な野菜と鶏肉を使った熱々の鍋料理で、締めにはうどんやご飯が提供されます。',
                    textCh1: '作为日本冬季的热门菜肴，火锅使用新鲜的蔬菜和鸡肉烹制，最后加入乌冬面和米饭。',
                    textCh2: '作為日本冬季的熱門菜餚，火鍋使用新鮮的蔬菜和雞肉烹製，最後加入烏冬麵和米飯。'
                },
                {
                    id: 1,
                    image: 'assets/images/foods/sm/foods-dinnerJ-1.jpg',
                    name: 'Shabu Shabu: JPY 7,000',
                    nameJ: 'しゃぶしゃぶ: 7,000円',
                    nameCh1: '涮涮锅：7,000日元',
                    nameCh2: '涮涮鍋：7,000日圓',
                    text: 'This classic Japanese hotpot dish features Nagano wagyu and Hakuba pork, accompanied by an abundance of vegetables, mushrooms, and tofu, finishing with udon noodles.',
                    textJ: 'この日本の定番料理は、長野和牛と白馬豚にたっぷりの野菜、きのこ、豆腐を添え、締めにうどんをお楽しみいただけます。',
                    textCh1: '这道经典的日式火锅以长野和牛和白马猪肉为主，配有大量的蔬菜、蘑菇和豆腐，最后以乌冬面收尾。',
                    textCh2: '這道經典的日式火鍋以長野和牛和白馬豬肉為主，配有大量的蔬菜、蘑菇和豆腐，最後以烏冬麵收尾。'
                },
                {
                    id: 2,
                    image: 'assets/images/foods/sm/foods-dinnerJ-2.jpg',
                    name: 'Sukiyaki: JPY 8,500',
                    nameJ: 'すき焼き: 8,500円',
                    nameCh1: '寿喜烧：8500日元',
                    nameCh2: '壽喜燒：8500日圓',
                    text: 'This classic Japanese dish features Nagano wagyu, along with an abundance of vegetables, mushrooms, and tofu, all cooked in sukiyaki sauce in a sukiyaki nabe, and finished with udon noodles.',
                    textJ: 'この日本の定番料理は、長野和牛とたっぷりの野菜、きのこ、豆腐をすき焼きのタレですき焼き鍋で調理し、最後にうどんで締めくくります。',
                    textCh1: '这道经典的日本菜肴以长野和牛、丰富的蔬菜、蘑菇和豆腐为主，使用寿喜烧酱在寿喜烧锅中烹制，最后以乌冬面收尾。',
                    textCh2: '這道經典的日本菜餚以長野和牛、豐富的蔬菜、蘑菇和豆腐為主，使用壽喜燒醬在壽喜燒鍋中烹製，最後以烏冬麵收尾。'
                }
                ]
            },
            {
            id: 3,
            category: 'foods',
            name: 'Snacks',
            nameJ: 'おつまみ',
            nameCh1: '小吃',
            nameCh2: '小吃',
            text: 'For a quick bite or snacks during the day, we offer cup noodles and protein bars at the bar counter for self-service.',
            textJ: '軽食やおやつとして、バーカウンターでカップヌードルやプロテインバーをご用意しています。セルフサービスでご利用いただけます。',
            textCh1: '为了快速就餐或白天的小吃，我们在吧台提供方便面和蛋白质棒，供自助服务。',
            textCh2: '為了快速就餐或白天的小吃，我們在吧台提供杯麵和蛋白棒，供自助使用。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/foods/sm/foods-snacks-0.jpg',
                    name: 'Cup noodles: JPY 250',
                    nameJ: 'カップヌードル: 250',
                    nameCh1: '方便面：250日元',
                    nameCh2: '杯麵：250日圓',
                    text: 'We offer several kinds of cup noodles for guests to choose from.',
                    textJ: 'ゲストが選べるように、いくつかの種類のカップラーメンを用意しています。',
                    textCh1: '我们提供几种杯面供客人选择。',
                    textCh2: '我們提供幾種杯麵供客人選擇。'
                },
                {
                    id: 1,
                    image: 'assets/images/foods/sm/foods-snacks-1.jpg',
                    name: 'Protein bar: JPY 300',
                    nameJ: 'プロテインバー: 300円',
                    nameCh1: '蛋白棒：300日元',
                    nameCh2: '蛋白棒：300日圓',
                    text: '',
                    textJ: '',
                    textCh1: '',
                    textCh2: ''
                }
                ]
            }
        ]
    },
    bars: {
        name: 'Bar',
        nameJ: 'バー',
        nameCh1: '酒吧',
        nameCh2: '酒吧',
        text: 'We offer a selection of Hakuba local beers and other popular drinks at our bar. The bar is open from 4:30 PM to 9:30 PM, with Happy Hour running from 4:30 PM to 6:00 PM.',
		textJ: '私たちのバーでは、白馬の地ビールやその他の人気の飲み物を取り揃えています。バーの営業時間は午後4時30分から9時30分までで、ハッピーアワーは午後4時30分から6時までです。',
		textCh1: '在我们的酒吧，我们提供白马本地啤酒和其他受欢迎的饮品。酒吧的营业时间是下午4:30到9:30，欢乐时光从下午4:30到6:00。',
		textCh2: '在我們的酒吧，我們提供白馬本地啤酒和其他受歡迎的飲品。酒吧的營業時間是下午4:30到9:30，歡樂時光從下午4:30到6:00。',
        drinks: [
            {
            id: 0,
            category: 'drinks',
            name: 'From the Taps',
            nameJ: 'タップから',
            nameCh1: '从龙头上',
            nameCh2: '從龍頭上',
            text: 'We serve draft Asahi Superdry, IPA from the local Hakuba Brewing Company, and flavored chuhai (Japanese shochu with ice and carbonation).',
            textJ: '生ビールとしてアサヒスーパードライ、地元の白馬ブルーイングカンパニーのIPA、そしてフレーバーチューハイ（日本の焼酎に氷と炭酸を加えた飲み物）をご提供しています。',
            textCh1: '我们提供生啤酒（包括朝日超级干）、来自当地白马酿造公司的IPA，以及风味清酒（日本烧酒加冰和碳酸饮料）。',
            textCh2: '我們提供生啤酒（包括朝日超乾）、來自當地白馬釀造公司的IPA，以及風味清酒（日本燒酒加冰和碳酸飲料）。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/drinks/drinks-taps-0.jpg',
                    name: 'Hakuba IPA: JPY 900',
                    nameJ: '白馬ブルーイングカンパニーのIPA: 900円',
                    nameCh1: '白马酿造公司的IPA：900日元',
                    nameCh2: '白馬釀造公司的IPA：900日圓',
                    text: '',
                    textJ: '',
                    textCh1: '',
                    textCh2: ''
                },
                {
                    id: 1,
                    image: 'assets/images/drinks/drinks-taps-1.jpg',
                    name: 'Asahi Super Dry: JPY 800',
                    nameJ: 'アサヒスーパードライ: 800円',
                    nameCh1: '朝日超干：800日元',
                    nameCh2: '朝日超乾：800日圓',
                    text: 'This refreshing and easy-to-drink beer is the most popular beer in Japan.',
                    textJ: 'この爽やかで飲みやすいビールは、日本で最も人気のあるビールです。',
                    textCh1: '这种清爽易饮的啤酒是日本最受欢迎的啤酒。',
                    textCh2: '這種清爽易飲的啤酒是日本最受歡迎的啤酒。'
                },
                {
                    id: 2,
                    image: 'assets/images/drinks/drinks-taps-2.jpg',
                    name: 'Flavored chuhai: JPY 600',
                    nameJ: 'フレーバーチューハイ: 600円',
                    nameCh1: '加味烧酒：600日元',
                    nameCh2: '加味燒酒：600日圓',
                    text: 'This flavoured mix Japanese shochu and soda water is very popular, especially among ladies. ',
                    textJ: 'この風味豊かな日本の焼酎とソーダ水のミックスは、特に女性に人気があります。',
                    textCh1: '这种风味混合的日本烧酒和苏打水非常受欢迎，尤其是在女性中。',
                    textCh2: '這種風味混合的日本燒酒和蘇打水非常受歡迎，尤其是在女性中。'
                }
                ]
            },
            {
            id: 1,
            category: 'drinks',
            name: 'From the Bottles',
            nameJ: '瓶から',
            nameCh1: '从瓶子里',
            nameCh2: '從瓶子裡',
            text: 'We offer ale and amber beers from Hakuba Brewing Company, a selection of whiskey, gin from Nozawa Onsen Brewery, wine, Japanese sake, and a variety of soft drinks.',
            textJ: '白馬ブルーイングカンパニーのエールとアンバービール、ウイスキーのセレクション、野沢温泉酒造のジン、ワイン、日本酒、そしてさまざまなソフトドリンクをご提供しています。',
            textCh1: '我们提供来自白马酿造公司的艾尔和琥珀啤酒、一系列威士忌、来自野泽温泉酒造的杜松子酒、葡萄酒、日本清酒以及各种软饮。',
            textCh2: '我們提供來自白馬釀造公司的艾爾和琥珀啤酒、一系列威士忌、來自野澤溫泉酒造的杜松子酒、葡萄酒、日本清酒以及各種軟飲。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/drinks/drinks-bottles-0.jpg',
                    name: 'Hakuba Ale or Amber: JPY 900',
                    nameJ: '白馬エールとアンバービール: 900円',
                    nameCh1: '白马艾尔和琥珀啤酒：900日元',
                    nameCh2: '白馬艾爾和琥珀啤酒：900日圓',
                    text: 'This is the bottled version of the popular local beer.',
                    textJ: 'これは人気の地元ビールの瓶詰めバージョンです。',
                    textCh1: '这是受欢迎的当地啤酒的瓶装版本。',
                    textCh2: '這是受歡迎的當地啤酒的瓶裝版本。'
                },
                {
                    id: 1,
                    image: 'assets/images/drinks/drinks-bottles-1.jpg',
                    name: 'Whiskey selection: JPY 800',
                    nameJ: 'ウイスキーのセレクション: 800円',
                    nameCh1: '一系列威士忌：800日元',
                    nameCh2: '一系列威士忌：800日圓',
                    text: 'We offer a selection of Western and Japanese whiskies, including Bowmore, Glenfiddich, Ao, and Miyagikyo.',
                    textJ: '私たちは、ボウモア、グレンフィディック、蒼（Ao）、宮城峡（Miyagikyo）など、さまざまな種類のウエスタンウイスキーと日本のウイスキーを提供しています。',
                    textCh1: '我们提供多种西方和日本威士忌，包括博摩尔、格兰菲迪、蒼（Ao）和宫城峡（Miyagikyo）。',
                    textCh2: '我們提供多種西方和日本威士忌，包括波摩、格蘭菲迪、蒼（Ao）和宮城峽（Miyagikyo）。'
                },
                {
                    id: 2,
                    image: 'assets/images/drinks/drinks-bottles-2.jpg',
                    name: 'Gin from Nozawa Onsen Brewery: JPY 800',
                    nameJ: '野沢温泉酒造のジン: 800円',
                    nameCh1: '野泽温泉酒造的杜松子酒：800日元',
                    nameCh2: '野澤溫泉酒造的杜松子酒：800日圓',
                    text: 'This sophisticated and well-balanced gin is produced in another resort town in Nagano. Be sure to try all four flavors.',
                    textJ: 'この洗練されたバランスの取れたジンは、長野の別のリゾートタウンで作られています。ぜひ4つのフレーバーをお試しください。',
                    textCh1: '这款精致平衡的金酒来自长野的另一个度假小镇。请务必尝试所有四种口味。',
                    textCh2: '這款精緻平衡的金酒來自長野的另一個度假小鎮。請務必嘗試所有四種口味。'
                },
                {
                    id: 3,
                    image: 'assets/images/drinks/drinks-bottles-3.jpg',
                    name: 'Japanese sake: JPY 800',
                    nameJ: '日本酒: 800円',
                    nameCh1: '日本清酒：800日元',
                    nameCh2: '日本清酒：800日圓',
                    text: 'TThis sake is produced near Hakuba using mountain water from the Northern Japanese Alps.',
                    textJ: 'この日本酒は、白馬の近くで北日本アルプスの山水を使用して製造されています。',
                    textCh1: '这款日本酒在白马附近生产，使用的是北日本阿尔卑斯山的山泉水。',
                    textCh2: '這款日本酒在白馬附近生產，使用的是北日本阿爾卑斯山的山泉水。'
                },
                {
                    id: 4,
                    image: 'assets/images/drinks/drinks-bottles-4.jpg',
                    name: 'Soft drinks: JPY 250',
                    nameJ: 'ソフトドリンク: 250円',
                    nameCh1: '软饮：250日元',
                    nameCh2: '軟飲：250日圓',
                    text: 'We offer Coca-Cola, ginger ale, tonic water, and fruit juices.',
                    textJ: 'コカ・コーラ、ジンジャーエール、トニックウォーター、そしてフルーツジュースを提供しています。',
                    textCh1: '我们提供可口可乐、姜汁啤酒、汤力水和果汁。',
                    textCh2: '我們提供可口可樂、姜汁啤酒、通寧水和果汁。'
                }
                ]
            },
            {
            id: 2,
            category: 'drinks',
            name: 'Snacks',
            nameJ: 'タップから',
            nameCh1: '从龙头上',
            nameCh2: '從龍頭上',
            text: 'We serve mixed nuts, vegetable chips, edamame, and chips with salsa.',
            textJ: 'ミックスナッツ、野菜チップス、枝豆、そしてサルサソース付きのチップスをご提供しています。',
            textCh1: '我们提供混合坚果、蔬菜脆片、毛豆和搭配莎莎酱的玉米片。',
            textCh2: '我們提供混合堅果、蔬菜脆片、毛豆以及搭配莎莎醬的玉米片。',
            items: [ 
                {
                    id: 0,
                    image: 'assets/images/drinks/drinks-snacks-0.jpg',
                    name: 'Mixed nuts: JPY 300',
                    nameJ: 'ミックスナッツ: 300円',
                    nameCh1: '混合坚果：300日元',
                    nameCh2: '混合堅果：300日圓',
                    text: 'Mixed nuts: JPY 300',
                    textJ: 'ミックスナッツ: 300円',
                    textCh1: '混合坚果：300日元',
                    textCh2: '混合堅果：300日圓'
                },
                {
                    id: 1,
                    image: 'assets/images/drinks/drinks-snacks-1.jpg',
                    name: 'Vegetable chips: JPY 400',
                    nameJ: '野菜チップス: 400円',
                    nameCh1: '蔬菜脆片：400日元',
                    nameCh2: '蔬菜脆片：400日圓',
                    text: 'This delicious snack features several types of vegetables in a condensed form while retaining their nutritional value.',
                    textJ: 'この美味しいスナックは、いくつかの種類の野菜を凝縮した形で提供しながら、栄養価を保っています。',
                    textCh1: '这个美味的小吃以浓缩的形式呈现多种蔬菜，同时保留了它们的营养价值。',
                    textCh2: '這個美味的小吃以濃縮的形式呈現多種蔬菜，同時保留了它們的營養價值。'
                },
                {
                    id: 2,
                    image: 'assets/images/drinks/drinks-snacks-2.jpg',
                    name: 'Edamame: JPY 300',
                    nameJ: '枝豆: 300円',
                    nameCh1: '毛豆：300日元',
                    nameCh2: '毛豆：300日圓',
                    text: 'Perhaps the most popular snack to accompany drinks in Japan, and it is healthy too!',
                    textJ: 'おそらく日本で最も人気のある飲み物のおつまみであり、健康にも良いです。',
                    textCh1: '这可能是日本最受欢迎的饮料小吃，而且也很健康。',
                    textCh2: '這可能是日本最受歡迎的飲料小吃，而且也很健康。'
                },
                {
                    id: 3,
                    image: 'assets/images/drinks/drinks-snacks-3.jpg',
                    name: 'Chips with Salsa: JPY 400',
                    nameJ: 'サルサソース付きのチップス: 400円',
                    nameCh1: '搭配莎莎酱的玉米片：400日元',
                    nameCh2: '搭配莎莎醬的玉米片：400日圓',
                    text: 'This is a classic Tex-Mex appetizer that pairs perfectly with any drink, or on its own. ',
                    textJ: 'これは一般的なテクスメックススタイルの前菜です。どんな飲み物とも相性が良く、飲み物がなくても楽しめます。',
                    textCh1: '这是一道标准的德克萨斯墨西哥风味开胃菜。它与所有饮品都很搭，当然可以单独享用。',
                    textCh2: '這是一道標準的德克薩斯墨西哥風味開胃菜。它與所有飲品都很搭，當然可以單獨享用。'
                }
                ]
            }
        ]
    }
}